import { createUseStyles } from 'react-jss'

import { MQ, COLOR } from 'utils/constants'

export const useStyles = createUseStyles({
  image: {
    borderRadius: 20,
    maxWidth: 500,
    margin: 'auto',
    [MQ.TABLET_LARGE]: {
      width: '46%',
      height: '100%',
      margin: 0,
      maxWidth: 'unset',
    },
  },

  imageWrapper: {
    width: '100%',
    height: '100%',
  },
  carouselImage: {
    borderRadius: 20,
  },

  carousel: {
    borderRadius: 20,
    maxWidth: 500,
    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    [MQ.TABLET_LARGE]: {
      width: '46%',
      height: '100%',
      margin: 0,
      maxWidth: 'unset',
    },
  },
  slider: {
    height: '100%',
  },
  slide: {
    height: '100%',
  },
  slideInner: {
    padding: [0, 10],
  },

  dots: {
    height: 50,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& button': {
      height: 15,
      width: 15,
      border: 'none',
      outline: 'none',
      borderRadius: '50%',
      backgroundColor: COLOR.DARK_GREEN,
      padding: 0,
      margin: [0, 10],
      '&:disabled': {
        backgroundColor: COLOR.LIGHT_GREEN,
      },
    },
  },
})
